var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-list"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"news-list-content"},[_c('HomeNewsListItem',{attrs:{"data":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }